import React, { Component } from "react";
import { Button } from "react-bootstrap";
import Swal from "sweetalert2";
import withReactContent from "sweetalert2-react-content";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import {
  updateFunnelStage,
  updateContentTag,
  deleteSettingsItem,
  updateContentProduct,
  updateContentIndustry,
  updateContentRegion,
  updateContentType
} from "../../actions/settings";
import AddContentItemForm from "./AddContentItemForm";
import AddContentTagForm from "./AddContentTagForm";
import DeleteConfirmForm from "./DeleteConfirmForm";
import { addEventNameToEndpoint } from '../../utils/common';
import "./EditTeamItem.scss";

const ReactSwal = withReactContent(Swal);

class EditTeamItem extends Component {
  getUpdateHandler = () => {
    switch (this.props.contentType) {
      case 'funnel':
        return this.props.updateFunnelStage;
      case 'product':
        return this.props.updateContentProduct;
      case 'industry':
        return this.props.updateContentIndustry;
      case 'region':
        return this.props.updateContentRegion;
      case 'type':
        return this.props.updateContentType;
      default:
        return this.props.updateFunnelStage;
    }
  }

  getListName = () => {
    switch (this.props.contentType) {
      case 'funnel':
        return 'funnelStages';
      case 'product':
        return 'contentProducts';
      case 'industry':
        return 'contentIndustries';
      case 'region':
        return 'contentRegions';
      case 'type':
        return 'contentTypes'
      default:
        return 'funnelStages';
    }
  }

  onAddStage = () => {
    ReactSwal.fire({
      allowOutsideClick: true,
      allowEscapeKey: true,
      allowEnterKey: false,
      showCancelButton: false,
      showConfirmButton: false,
      html: (
        <AddContentItemForm
          type={this.props.contentType}
          onClose={ReactSwal.clickConfirm}
          onAddContent={this.getUpdateHandler()}
          values={this.props.funnelStage}
          contentName={this.props.value}
          Analytics={this.props.Analytics}
        />
      )
    })
    .then(result => {
      if (result.value) {
        
      }
    });
  }

  onEditContentTag = () => {
    ReactSwal.fire({
      allowOutsideClick: true,
      allowEscapeKey: true,
      allowEnterKey: false,
      showCancelButton: false,
      showConfirmButton: false,
      html: (
        <AddContentTagForm
          onClose={ReactSwal.clickConfirm}
          onAddContentTag={this.props.updateContentTag}
          contentTag={this.props.contentTag}
          contentTagName={this.props.value}
          isEditing={true}
          Analytics={this.props.Analytics}
        />
      )
    })
    .then(result => {
      if (result.value) {
        
      }
    });
  }

  handleDeleteSettings = () => {
    const settingsKey = this.props.value;

    ReactSwal.fire({
      allowOutsideClick: true,
      allowEscapeKey: true,
      allowEnterKey: false,
      showCancelButton: false,
      showConfirmButton: false,
      html: (
        <DeleteConfirmForm
          type='settingsItem'
          settingsKey={settingsKey}
          onClose={ReactSwal.clickCancel}
          onConfirm={ReactSwal.clickConfirm}
        />
      )
    })
    .then(result => {
      if (result.value) {
        if (this.props.stage) {
          addEventNameToEndpoint(this.props.Analytics, 'admin-funnelStage-delete');

          this.props.Analytics.record({name: 'admin-funnelStage-delete', attributes: { funnelStageName: this.props.value }});
        } else {
          addEventNameToEndpoint(this.props.Analytics, 'admin-tag-delete');

          this.props.Analytics.record({name: 'admin-tag-delete', attributes: { contentTagName: this.props.value }});
        }

        this.props.deleteSettingsItem({
          listName: this.props.contentType ? this.getListName() : 'contentTags',
          itemName: this.props.value
        })
      }
    });
  }

  render() {
    const {
      value,
      stage,
      buttonTitle,
      type,
      contentTag
    } = this.props;

    return (
      <div className="edit-item d-flex justify-content-between align-items-end w-100">
        <div className="info">
          {type === "color" && <div className="color" style={{ backgroundColor: contentTag.color }}></div>}
          {this.props.contentType === 'funnel' ? <div className="value">{stage ? `${stage} - ${value}` : value}</div> : <div className="value">{value}</div>}
        </div>
        <div className="action-buttons">
          {this.props.editable && <Button variant="outline-danger mr-1" size="sm" onClick={type === 'color' ? this.onEditContentTag : this.onAddStage}>{buttonTitle}</Button>}
          {this.props.editable && <Button variant="outline-danger" size="sm" onClick={this.handleDeleteSettings}>DELETE</Button>}
        </div>
      </div>
    );
  }
}

const mapStateToProps = state => ({
  Analytics: state.auth.Analytics
});

const mapDispatchToProps = dispatch => 
bindActionCreators({
  updateFunnelStage,
  updateContentTag,
  deleteSettingsItem,
  updateContentProduct,
  updateContentIndustry,
  updateContentRegion,
  updateContentType
}, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(EditTeamItem);
